var _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _path8, _path9, _path10, _path11, _polygon2, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameOver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "224.038px",
    viewBox: "0 0 300 224.038",
    enableBackground: "new 0 0 300 224.038",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.437,98.543c-13.718,0-24.004-3.443-31.447-10.526C9.766,81.031,5.8,70.862,5.8,59.362 c0.109-24.445,17.917-40.856,44.312-40.856c9.639,0,17.289,1.916,21.235,3.709l3.063,1.392l-5.4,20.757l-4.339-1.994 c-2.875-1.321-6.865-2.671-14.665-2.671c-5.849,0-19.454,1.834-19.454,18.826c0,11.985,7.04,19.14,18.5,19.14 c1.489,0,2.947-0.08,3.947-0.188v-7.862H42v-20h34v43.813l-2.713,0.923C67.333,96.378,57.677,98.543,48.437,98.543z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.8975,
    y1: 94.5435,
    x2: 40.8975,
    y2: 22.5059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    style: {
      stopColor: "#F26828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2526,
    style: {
      stopColor: "#F48124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    style: {
      stopColor: "#F79420"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6188,
    style: {
      stopColor: "#F8A11C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#F9AA19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAAC18"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M71.995,90.564c-4.921,1.675-14.24,3.979-23.559,3.979c-12.879,0-22.198-3.246-28.689-9.423 C13.36,78.942,9.8,69.728,9.8,59.362c0.105-23.454,17.172-36.856,40.312-36.856c9.109,0,16.125,1.78,19.58,3.351l-3.351,12.879 c-3.875-1.78-8.586-3.037-16.334-3.037c-13.297,0-23.454,7.434-23.454,22.826c0,14.659,9.214,23.14,22.302,23.14 c3.56,0,6.492-0.418,7.749-0.942V65.854h-10.89v-12.46h26.281V90.564z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.619,97.615l-5.445-18h-14.192l-5.026,18H75.079l23.898-78h26.849l24.48,78H124.619z M114.501,59.615l-2.553-8.693 l-2.432,8.693H114.501z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.6729,
    y1: 93.8105,
    x2: 112.6729,
    y2: 23.2388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    style: {
      stopColor: "#F26828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2526,
    style: {
      stopColor: "#F48124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    style: {
      stopColor: "#F79420"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6188,
    style: {
      stopColor: "#F8A11C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#F9AA19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAAC18"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M101.941,75.696l-5.026,18.114H80.476l21.465-70.572h20.941l21.988,70.572h-17.276l-5.445-18.114 H101.941z M119.845,63.76l-4.397-14.973c-1.256-4.188-2.513-9.424-3.56-13.612h-0.209c-1.047,4.188-2.094,9.528-3.246,13.612 l-4.188,14.973H119.845z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.236,97.615l-1.315-30.746c-0.039-1.034-0.079-2.09-0.119-3.259c-0.295,0.919-0.588,1.827-0.88,2.715l-9.443,30.29 h-18.445L173.798,66.8c-0.005,0.093-1.568,30.815-1.568,30.815h-22.829l5.013-78h28.003l7.753,26.245 c0.909,3.22,1.772,6.394,2.581,9.66c0.954-3.523,1.913-6.725,2.846-9.765l8.329-26.14h27.662l4.197,78H212.236z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.6152,
    y1: 93.8105,
    x2: 192.6152,
    y2: 23.2388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    style: {
      stopColor: "#F26828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2526,
    style: {
      stopColor: "#F48124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    style: {
      stopColor: "#F79420"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6188,
    style: {
      stopColor: "#F8A11C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#F9AA19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAAC18"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M214.917,66.796c-0.314-8.481-0.628-18.742-0.628-29.003h-0.21 c-2.303,9.005-5.235,19.057-7.957,27.328l-8.586,27.538h-12.46l-7.539-27.224c-2.304-8.376-4.607-18.428-6.387-27.642h-0.21 c-0.313,9.528-0.732,20.417-1.151,29.213l-1.361,26.805h-14.764l4.503-70.572h21.255l6.91,23.559 c2.304,8.167,4.398,16.962,5.969,25.234h0.419c1.885-8.167,4.293-17.486,6.701-25.339l7.434-23.454h20.941l3.77,70.572h-15.496 L214.917,66.796z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "241,97.615 241,19.615 292,19.615 292,40.615 265,40.615 265,46.615 291,46.615 291,67.615 265,67.615 265,76.615  294,76.615 294,97.615  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.4277,
    y1: 93.8105,
    x2: 267.4277,
    y2: 23.2388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    style: {
      stopColor: "#F26828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2526,
    style: {
      stopColor: "#F48124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    style: {
      stopColor: "#F79420"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6188,
    style: {
      stopColor: "#F8A11C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#F9AA19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAAC18"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M286.85,63.969h-25.967v16.753h29.004v13.088h-44.919V23.239h43.452v13.088h-27.537v14.659h25.967 V63.969z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.818,205.609c-21.898,0-37.192-16.456-37.192-40.019c0-24.117,15.768-40.961,38.344-40.961 c22.083,0,37.506,16.37,37.506,39.81C94.476,189.449,79.302,205.609,55.818,205.609z M56.656,145.299 c-9.722,0-13.171,10.763-13.171,19.979c0,9.07,3.45,19.663,13.171,19.663c9.567,0,12.962-10.762,12.962-19.978 C69.618,155.175,65.61,145.299,56.656,145.299z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.5513,
    y1: 201.6094,
    x2: 56.5513,
    y2: 128.6299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    style: {
      stopColor: "#F26828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2526,
    style: {
      stopColor: "#F48124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    style: {
      stopColor: "#F79420"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6188,
    style: {
      stopColor: "#F8A11C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#F9AA19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAAC18"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M90.476,164.439c0,23.244-13.926,37.17-34.658,37.17c-20.836,0-33.192-15.811-33.192-36.019 c0-21.15,13.612-36.961,34.344-36.961C78.644,128.63,90.476,144.859,90.476,164.439z M39.484,165.277 c0,13.926,6.492,23.663,17.171,23.663c10.785,0,16.962-10.261,16.962-23.978c0-12.774-5.968-23.664-16.962-23.664 C45.767,141.299,39.484,151.561,39.484,165.277z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.991,204.615l-25.18-79h25.979l9.419,32.87c0.932,3.281,1.822,6.519,2.66,9.669c0.824-3.068,1.707-6.283,2.646-9.427 l9.857-33.112h25.51l-26.463,79H114.991z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.8047,
    y1: 200.458,
    x2: 127.8047,
    y2: 129.8867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    style: {
      stopColor: "#F26828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2526,
    style: {
      stopColor: "#F48124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    style: {
      stopColor: "#F79420"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6188,
    style: {
      stopColor: "#F8A11C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#F9AA19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAAC18"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M117.91,200.458l-22.616-70.571h17.486l8.586,29.841c2.408,8.481,4.607,16.438,6.282,25.234h0.314 c1.78-8.481,3.979-16.858,6.387-24.92l9.005-30.155h16.962l-23.768,70.571H117.91z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "165,204.615 165,125.615 216,125.615 216,146.615 189,146.615 189,153.615 215,153.615 215,174.615 189,174.615  189,183.615 218,183.615 218,204.615  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.4648,
    y1: 200.458,
    x2: 191.4648,
    y2: 129.8867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    style: {
      stopColor: "#F26828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2526,
    style: {
      stopColor: "#F48124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    style: {
      stopColor: "#F79420"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6188,
    style: {
      stopColor: "#F8A11C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#F9AA19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAAC18"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M210.887,170.617H184.92v16.753h29.004v13.088h-44.919v-70.571h43.452v13.088H184.92v14.659h25.967 V170.617z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M260.351,204.615l-1.106-2.289c-1.37-2.738-3.243-9.144-5.139-17.422c-1.739-7.78-3.645-8.289-7.787-8.289H246v28h-24 V127.43l3.285-0.548c5.911-0.966,13.858-1.52,21.865-1.52c11.899,0,19.688,1.978,25.291,6.413 c5.301,4.137,8.104,10.369,8.104,18.005c0,7.866-4.06,14.022-9.177,17.827c3.361,3.527,4.993,8.155,5.991,11.794 c0.665,2.438,1.318,4.974,1.945,7.406c1.249,4.844,2.664,10.413,3.429,11.94l2.893,5.867H260.351z M247.953,157.615 c3.237,0,8.669-1.011,8.669-6.367c0-1.569,0.165-5.844-7.562-5.844c-1.329,0-2.061-0.079-3.061-0.039v12.25H247.953z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.5078,
    y1: 200.458,
    x2: 252.5078,
    y2: 129.3623
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    style: {
      stopColor: "#F26828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2526,
    style: {
      stopColor: "#F48124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    style: {
      stopColor: "#F79420"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6188,
    style: {
      stopColor: "#F8A11C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8057,
    style: {
      stopColor: "#F9AA19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAAC18"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M225.859,130.829c5.131-0.838,12.67-1.467,21.256-1.467c10.471,0,17.8,1.571,22.826,5.55 c4.293,3.351,6.596,8.377,6.596,14.868c0,8.9-6.387,15.078-12.46,17.276v0.314c4.922,1.989,7.644,6.597,9.424,13.088 c2.199,8.063,4.293,17.276,5.654,19.999h-16.334c-1.048-2.094-2.827-7.748-4.816-16.438c-1.99-8.9-5.026-11.204-11.623-11.309 h-4.712v27.747h-15.811V130.829z M241.67,161.193h6.283c7.957,0,12.669-3.979,12.669-10.156c0-6.388-4.397-9.738-11.727-9.738 c-3.875,0-6.073,0.21-7.226,0.523V161.193z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameOver);
export default __webpack_public_path__ + "static/media/game-over.386120eb1d302d85ff41e0db5112e6c2.svg";
export { ForwardRef as ReactComponent };